var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CButton',{staticClass:"toggle-button px-2",attrs:{"variant":"link"},on:{"click":function($event){return _vm.toggleNav()}}},[_c('fa',{style:({ color: _vm.getTemplateOption('header_text_color') }),attrs:{"icon":_vm.icons.faBars}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }